import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import ShiftPlannerIMg from "../../../../../Assets/Images/CycleLandingImage.png";
import If from "../../../../../Component/Common/If";
import { ReducersTypes } from "../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class AttendanceCycle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CycleInfo: [],
      port: window.location.port,
      requestcycleid: "",
      remArray: [],
      value: 0,
      ticks: { placement: "after", largeStep: 1 },
      ticksData: { placement: "Both", largeStep: 1, smallStep: 1 },
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      actionidList: "",
      cycleinforeceived: false,
      permissions: { readOnly: false, editable: false },
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendencecycle");
    const d = new Date();
    const Month = this.state.month[d.getMonth()];
    this.setState({ month: Month });
    this.getRequestCycle();
  }

  componentWillUnmount() {
    this.props.CommonReducerAction(`${ReducersTypes.LANGUAGE}_PENDING`);
    this.HelperSliderFlag("");
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("requestCycle");
    if (isTrue) {
      this.setState({ permissions });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  HelperSliderFlag(HtField) {
    if (HtField != "") {
      const text = this.props.Language.attendencecycle[HtField];
      this.props.setHelperText({ helperText: text, open: true });
    } else {
      this.props.setHelperText({ helperText: "", open: true });
    }
  }

  ConfigureCycle(e) {
    this.props.history.push("./configurecycle");
  }

  EditCycle(requestcycleid, e) {
    this.props.history.push(`./configurecycle/${requestcycleid}`);
  }

  getRequestCycle() {
    instance
      .get("/attendance/getrequestcycle")
      .then((result) => {
        let CycleInfo = [];
        result.data.result.length > 0
          ? (CycleInfo = result.data.result)
          : (CycleInfo = []);
        let requestcycleid = "";
        result.data.result.length > 0
          ? (requestcycleid = result.data.result[0].requestcycleid)
          : (requestcycleid = "");
        let remArray = [];
        let value;
        if (result.data.result.length > 0) {
          if (
            CycleInfo[0].regularizationcutoff == null
            // || CycleInfo[0].regularizationcutoff == undefined
          ) {
            value = 0;
          } else {
            value = CycleInfo[0].regularizationcutoff;
          }

          if (
            CycleInfo[0].attendancereminder != "" &&
            CycleInfo[0].attendancereminder != null
          ) {
            remArray = CycleInfo[0].attendancereminder.split(",");
          }
        }
        this.setState({
          CycleInfo,
          requestcycleid,
          remArray,
          value,
          cycleinforeceived: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const { value } = this.state;
    const language = this.props.Language.attendencecycle;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <div>
            <div className="innerwrapperheader2">
              <div className="innerwrapper-page-header">
                Attendance / Request cycle
              </div>
            </div>
            <div className="content-subwrapper">
              <If condition={this.state.cycleinforeceived}>
                {this.state.CycleInfo.length <= 0 ? (
                  <Grid container className="margin-left-30">
                    <Grid item xs={12} md={6} sm={6}>
                      <h5>
                        {" "}
                        <FormattedMessage
                          id="LbCycleHeading"
                          defaultMessage="Concept of Cycle"
                        />
                      </h5>
                      <p className="cycle-desc">
                        <FormattedMessage
                          id="LbCycleHeading1"
                          defaultMessage="Cycle serves the specific purpose of reducing the amount"
                        />{" "}
                        <br />
                        <FormattedMessage
                          id="LbCycleHeading2"
                          defaultMessage="of time Human Resource department has to spend on"
                        />{" "}
                        <br />
                        <FormattedMessage
                          id="LbCycleHeading3"
                          defaultMessage="fixing the gaps in attendance of an employee. These gaps in"
                        />{" "}
                        <br />
                        <FormattedMessage
                          id="LbCycleHeading4"
                          defaultMessage="attendance appear as a result of employee missing to register"
                        />
                        <br />
                        <FormattedMessage
                          id="LbCycleHeading5"
                          defaultMessage="a punch (clock-in or clock-out). Or due to employees not"
                        />
                        <br />
                        <FormattedMessage
                          id="LbCycleHeading6"
                          defaultMessage="meeting criterias set in Attendance Policy & Action."
                        />
                        <br />
                      </p>
                      <div className="margin-top-60">
                        {this.state.permissions.editable ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            type="button"
                            onClick={this.ConfigureCycle.bind(this)}
                          >
                            <FormattedMessage
                              id="BtconfigureCycle"
                              defaultMessage="CONFIGURE CYCLE"
                            />
                          </Button>
                        ) : (
                          ""
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={5} sm={6}>
                      <img src={ShiftPlannerIMg} align="right" />
                    </Grid>
                  </Grid>
                ) : (
                  <div>
                    <Grid container height="100%" width="100%">
                      {this.state.CycleInfo[0].attendancecycletypeid == 1 ? (
                        <Grid item xs={12} md={6} sm={6}>
                          <div
                            className="requestCycleLabels"
                            style={{ width: 225 }}
                          >
                            <FormattedMessage
                              id="LbRequestCycle"
                              defaultMessage="Request Cycle"
                            />
                          </div>

                          <div className="Subtitle-1 margin-top-20">
                            {this.state.CycleInfo[0].attendancecycletypename}
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={12} sm={6}>
                          <div
                            className="requestCycleLabels"
                            style={{ width: 225 }}
                          >
                            <FormattedMessage
                              id="LbRequestCycle"
                              defaultMessage="Request Cycle"
                            />
                          </div>

                          <div className="Subtitle-1 margin-top-20 margin-bottom-20">
                            {this.state.CycleInfo[0].attendancecycletypename}
                          </div>
                          {this.state.CycleInfo[0].attendancecycletypeid ==
                          2 ? (
                            <div>
                              <div className="requestCycleLabels">
                                <FormattedMessage
                                  className="Subtitle-1"
                                  id="LbCycleDate"
                                  defaultMessage="Selected Cycle Date"
                                />
                              </div>
                              <div className="Subtitle-1 margin-top-10 margin-bottom-20">
                                {this.state.CycleInfo[0].customenddate}
                              </div>
                              <div className="Subtitle-1 margin-top-20 margin-bottom-20">
                                <FormattedMessage
                                  className="Subtitle-1"
                                  id="LbCycleEndOn"
                                  defaultMessage="Based on your above selection, your monthly attendance cycle will end on:"
                                />{" "}
                                <span className="requestCycleLabels margin-left-5">
                                  {this.state.CycleInfo[0].customenddate}
                                </span>
                              </div>
                              {this.state.CycleInfo[0].customenddate == 30 ||
                              this.state.CycleInfo[0].customenddate == 31 ? (
                                <div className="margin-top-10 ">
                                  <span className="Note">
                                    <FormattedMessage
                                      id="LbNote"
                                      defaultMessage="NOTE: Your monthly attendance cycle will end on last day of the month."
                                    />
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                              {this.state.CycleInfo[0].customenddate == 29 ? (
                                <div className="margin-top-10 ">
                                  <span className="Note">
                                    <FormattedMessage
                                      id="LbNoteFebruary"
                                      defaultMessage="NOTE: Your monthly attendance cycle will end on last day of February."
                                    />
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.CycleInfo[0].attendancecycletypeid ==
                          3 ? (
                            <div>
                              {" "}
                              Based on your above selection, your monthly
                              attendance cycle will end on last day of the
                              month.
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="requestCycleLabels margin-top-30">
                            <FormattedMessage
                              id="LbReminders"
                              defaultMessage="Automatic Reminders"
                            />
                          </div>
                          {this.state.remArray[0] != 0 &&
                          this.state.remArray[0] != "undefined" ? (
                            <div>
                              <div className="Subtitle-1 margin-top-20 reminderCol ">
                                <span>
                                  {" "}
                                  <FormattedMessage
                                    className="Subtitle-1"
                                    id="LbRem1"
                                    defaultMessage="Reminder 1"
                                  />
                                </span>
                              </div>

                              <div className="Subtitle-1 margin-top-6 margin-bottom-20">
                                {this.state.remArray[0]}{" "}
                                <FormattedMessage
                                  id="LbNoOfDays"
                                  defaultMessage="Days Before cut-off"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.remArray[1] != 0 &&
                          this.state.remArray[1] != "undefined" ? (
                            <div>
                              <div className="Subtitle-1 margin-top-20 reminderCol ">
                                <span>
                                  <FormattedMessage
                                    className="Subtitle-1"
                                    id="LbRem2"
                                    defaultMessage="Reminder 2"
                                  />
                                </span>
                              </div>
                              <div className="Subtitle-1 margin-top-6 margin-bottom-20">
                                {this.state.remArray[1]}{" "}
                                <FormattedMessage
                                  id="LbNoOfDays"
                                  defaultMessage="Days Before cut-off"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.remArray[2] != 0 &&
                          this.state.remArray[2] != "undefined" ? (
                            <div>
                              <div className="Subtitle-1 margin-top-20 reminderCol ">
                                <span>
                                  <FormattedMessage
                                    className="Subtitle-1"
                                    id="LbRem3"
                                    defaultMessage="Reminder 3"
                                  />
                                </span>
                              </div>

                              <div className="Subtitle-1 margin-top-6 margin-bottom-20">
                                {this.state.remArray[2]}{" "}
                                <FormattedMessage
                                  className="Subtitle-1"
                                  id="LbNoOfDays"
                                  defaultMessage="Days Before cut-off"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div>
                            {/* <div className="padding-top-30 requestCycleLabels">
                                                        <FormattedMessage id="LbRegulizationCutoff" defaultMessage="Regularization Cutoff" />
                                                    </div>
                                                    <div className="padding-top-30">
                                                        <Slider
                                                            value={value}

                                                            min={-10}
                                                            max={10}
                                                            step={1}
                                                            className="number-filter-slider RodWidth"
                                                        />
                                                        <div className="padding-top-15">{this.state.value}</div> */}

                            {/* </div> */}

                            <div className="control-pane cycleView">
                              <div className="control-section">
                                <div className="slider-content-wrapper">
                                  <div className="margin-top-20">
                                    <div
                                      className="margin-top-20"
                                      id="slider_wrapper"
                                    >
                                      <div className="requestCycleLabels">
                                        Regularization Cutoff
                                      </div>
                                      <Slider
                                        value={value}
                                        min={-10}
                                        max={10}
                                        step={1}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p className="Select-the-Long-Leav ColorBlack inlindClass margin-bottom-30">
                                <React.Fragment>
                                  {" "}
                                  <FormattedMessage
                                    id="LbRegCut1"
                                    defaultMessage={`Your employee's access to update attendance logs will be capped`}
                                  />{" "}
                                  {
                                    <span>
                                      {this.state.value > 0 && this.state.value}
                                    </span>
                                  }{" "}
                                  {this.state.value > 0 ? (
                                    <FormattedMessage
                                      id="LbRegCut2-1"
                                      defaultMessage={`days after your attendance cycle’s end date.`}
                                    />
                                  ) : this.state.value < 0 ? (
                                    <FormattedMessage
                                      id="LbRegCut2-2"
                                      defaultMessage={`days before your attendance cycle’s end date.`}
                                    />
                                  ) : (
                                    <FormattedMessage
                                      id="LbRegCut2-3"
                                      defaultMessage={`on same day of  your attendance cycle’s end date.`}
                                    />
                                  )}
                                </React.Fragment>
                              </p>
                            </div>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                    {this.state.permissions.editable && (
                      <div className="draftbutton-wrapper">
                        <div
                          className="draftbutton-innerwrapper cursour-pointer"
                          onClick={this.EditCycle.bind(
                            this,
                            this.state.requestcycleid,
                          )}
                        >
                          <span className="editbutton">
                            <span className="editbutton-svg">
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                <path d="M0 0h24v24H0z" fill="none" />
                              </svg>
                            </span>
                            <span className="edit-option">Edit</span>
                          </span>
                        </div>
                      </div>
                    )}
                    {/* <div className="draftbutton-wrapper">
                                    <Button variant="fab" color="primary" aria-label="Add" className="floatright margin-top-40 editBottom" onClick={this.EditCycle.bind(this, this.state.requestcycleid)}>
                                        <EditIcon />
                                    </Button>
                                    </div> */}
                  </div>
                )}
              </If>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(AttendanceCycle)));
